export type Menu = MenuItem[];

export enum MenuFlags {
    'LOGGED_IN' = 'LOGGED_IN'
}

export interface MenuItem {
    name: string;
    key: string;
    url: string;
    flags?: MenuFlags[] | string[];
}

type ConDitionsState = { loggedIn?: boolean };

export function matchesMenuItemCondition(flags: MenuFlags[] | string[], state: ConDitionsState): boolean {
    if (!flags || !flags.length) {
        return true;
    }

    if (flags.includes(MenuFlags.LOGGED_IN)) {
        return state?.loggedIn;
    }
}
